import { render } from "./Footer.vue?vue&type=template&id=bc4e50b2&scoped=true"
const script = {}

import "./Footer.scss?vue&type=style&index=0&id=bc4e50b2&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4e50b2"]])

export default __exports__